module.exports = __webpack_public_path__ + "static/img/waves-status.2206da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/waves-status.png
// module id = yMXj
// module chunks = 0